import {combineReducers} from 'redux'
import createLoggedInUserReducer from '../loggedInUser/reducer'
import createEntitiesReducer from '../entities/reducer'
import createAssignmentsReducer from '../assignments/reducer'
import createTaskManagementReducer from '../taskManagement/reducer'
import createPanelsReducer from '../panels/reducer'
import workflowSettings from '../administration/workflowSettings/reducer'
import createLicensesReducer from '../administration/licenses/licenseReducer'
import createDARSettingsReducer from '../administration/darSettings/reducer'
import createUserManagementReducer from '../administration/userManagement/reducer'
import createFeaturesReducer from '../features/reducer'
import createUserProfileReducer from '../userProfile/reducer'
import createReportsReducer from '../reports/reducer'
import createPasswordReducer from '../administration/passwordSettings/reducer'
import createMailReducer from '../administration/mailSettings/reducer'
import toasts from '../toasts/reducer'
import createWorkScheduleReducer from '../administration/workSchedule/workScheduleReducer'
import createLicenseCountDownTipReducer from '../components/licenseCountDownTip/reducer'
import createSupportReducer from '../support/supportForm/reducer'

export default (initAppData) => {
    return combineReducers({
        loggedInUser: createLoggedInUserReducer(initAppData),
        entities: createEntitiesReducer(initAppData),
        assignments: createAssignmentsReducer(initAppData),
        taskManagement: createTaskManagementReducer(initAppData),
        panels: createPanelsReducer(initAppData),
        userProfile: createUserProfileReducer(initAppData),
        workflowSettings,
        darSettings: createDARSettingsReducer(initAppData),
        passwordSettings: createPasswordReducer(initAppData),
        mailSettings: createMailReducer(initAppData),
        userManagement: createUserManagementReducer(initAppData),
        features: createFeaturesReducer(initAppData),
        reports: createReportsReducer(initAppData),
        workSchedule: createWorkScheduleReducer(initAppData),
        toasts,
        licenses: createLicensesReducer(initAppData),
        licenseCountDownTip: createLicenseCountDownTipReducer(initAppData),
        support: createSupportReducer(initAppData),
    })
}



// WEBPACK FOOTER //
// ./web/js/redux/reducer.js